<template>
  <div>
    <div class="grid-x container banner-description">
      <div class="large-12 cell">
        <h2 class="text-center">
          Enquiry submitted! <br />
           <router-link :to="{name: 'orderDetail', params: {orderId: enquiryId}}"
           class="button clear"
           >
            #{{enquiryNumber}}
          </router-link>
        </h2>
       
        <!-- <h5 class="text-center">
          We are working on it to get you a feedback ASAP.
        </h5> -->
      </div>
    </div>
    <!-- <div class="grid-x">
      <div class="large-12 cell">
        <p class="text-center">&nbsp;</p>
      </div>
    </div> -->
    <div class="grid-container container first">
      <div class="grid-x grid-padding-x layout">
        <div class="cell medium-6 large-4 large-centered">
          <div class="callout">
            <p>
              Your enquiry 
              was already submitted to us and you will receive a notification in your email.
            </p>
            <router-link :to="{name:'search', params: {query:'all'}}"
            class="h5 button radius"
            >
              Back To Selection
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="container"></div>
  </div>
</template>

<script>
// import accountRepository from "@/app.account/services/main-service.js";

export default {
  name: "appMessageBox",
  props: {
    enquiryNumber: null,
    enquiryId: null
  },
  mixins: [require("@/app/mixins/foundation")],
  data() {
    return {
      model: {},
      
       isValid: false,
      loading: false,
      errored: false,
    };
  },
  mounted () {
    let _this = this;

    $(this.$refs.f)
      .on("invalid.zf.abide", function() {
        _this.isValid = false;
      })
      .on("formvalid.zf.abide", function() {
        _this.isValid = true;
      })
      .on("submit", function(ev) {
        ev.preventDefault();

        if (_this.isValid) {
          _this.onSubmit();
        } else {
          // console.log("error");
        }
      });
  },
  methods: {
    //async onSubmit() {
    onSubmit() {
      this.$refs.f.login.disabled = true;
      //let _this = this;

      try {
        // const { data } = await accountRepository.login({
        //   UserName: this.model.UserName
        // });

        //if (data.succeeded) {
          // sessionStorage.setItem("Roles", data.roles);
          // sessionStorage.setItem("Claims", data.claims);
          // _this.$router.push("desktop");
          //console.log(sessionStorage.getItem("Roles"));
        //}
        // console.log('TODO: go to email has been sent');


      } catch (error) {
        this.errored = true;
      } finally {
        this.loading = this.$refs.f.login.disabled = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.layout {
  padding-top: 1.5rem;
  .large-centered {
    margin: 0 auto;
  }
}
// .banner-description{
//   background-image: linear-gradient(to bottom right, #cec9c9, white);
// }
</style>
